import { Middleware } from 'redux'
import { isRSAA, RSAA, RSAAFailureType, RSAARequestType, RSAASuccessType } from 'redux-api-middleware'
import { RootState } from '../../../reducers'
import AbortionClinic from './AbortionClinic'

type RSAAType = RSAARequestType | RSAASuccessType | RSAAFailureType

function getRSAActionType(action: RSAAType | RSAAType[]): string {
    // If RSA Action has an array of actions (most of the times),
    // take the first one (request initiated) as the action that identifies the request
    if (Array.isArray(action) && action.length > 0) {
        return getRSAActionType(action[0])
    }

    // First check in if case is stupid, but it's needed for TS not
    // to think action can still be an array
    if (!Array.isArray(action) && typeof action === 'object') {
        return action.type.toString()
    }

    return action.toString()
}

/**
 * Sets headers for API calls
 */
const APIAbortions: Middleware<{}, RootState> = () => (next) => (action) => {
    if (!isRSAA(action)) {
        AbortionClinic.deleteAgendaEntry(action.type)
        return next(action)
    }

    try {
        const {
            [RSAA]: { types, options },
        } = action
        const { abortable } = options || {}

        if (!abortable) {
            return next(action)
        }

        const signal: AbortSignal = AbortionClinic.getSignal(getRSAActionType(types))

        return next({
            ...action,
            [RSAA]: {
                ...action[RSAA],
                options: {
                    signal,
                },
            },
        })
    } catch (error) {
        console.error(error)
    }

    return next(action)
}

export default APIAbortions
